import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.MoveOrder.components.MoveOrderModal.title',
    defaultMessage: 'Move order',
  },
  selectCustomerLabel: {
    id: 'containers.OrderPage.components.OverviewPage.components.MoveOrder.components.MoveOrderModal.selectCustomerLabel',
    defaultMessage: 'Customer',
  },
  selectCustomerDescription: {
    id: 'containers.OrderPage.components.OverviewPage.components.MoveOrder.components.MoveOrderModal.selectCustomerDescription',
    defaultMessage: 'Select the customer to which the order needs to be moved',
  },
  selectCustomerPlaceholder: {
    id: 'containers.OrderPage.components.OverviewPage.components.MoveOrder.components.MoveOrderModal.selectCustomerPlaceholder',
    defaultMessage: 'Customer name',
  },
  selectContactLabel: {
    id: 'containers.OrderPage.components.OverviewPage.components.MoveOrder.components.MoveOrderModal.selectContactLabel',
    defaultMessage: 'Contact',
  },
  selectContactDescription: {
    id: 'containers.OrderPage.components.OverviewPage.components.MoveOrder.components.MoveOrderModal.selectContactDescription',
    defaultMessage: 'Select the preferred contact',
  },
  selectContactPlaceholder: {
    id: 'containers.OrderPage.components.OverviewPage.components.MoveOrder.components.MoveOrderModal.selectContactPlaceholder',
    defaultMessage: 'Contact name',
  },
  moveOrder: {
    id: 'containers.OrderPage.components.OverviewPage.components.MoveOrder.components.MoveOrderModal.moveOrder',
    defaultMessage: 'Move order',
  },
  moveLoading: {
    id: 'containers.OrderPage.components.OverviewPage.components.MoveOrder.components.MoveOrderModal.moveLoading',
    defaultMessage: 'Moving...',
  },
})
